import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AlertController, LoadingController, ModalController, NavController, ToastController} from "@ionic/angular";
import {ActivatedRoute} from "@angular/router";
import {ServerService} from "../../../service/server.service";
import {AdminService} from "../../../service/admin.service";
import {FormBuilder, NgForm} from "@angular/forms";
import {IntegrationService} from "../../../service/integration.service";
import {Constant} from "../../../shared/model/Constant";

@Component({
  selector: 'app-setting-add',
  templateUrl: './setting-add.page.html',
  styleUrls: ['./setting-add.page.scss'],
})
export class SettingAddPage implements OnInit {
  @ViewChild('form', {static: false}) ngForm: NgForm;
  data: any;
  states: any;
  percentage: string;
  value: string;
  percentageFlag;
  valueFlag;
  categories: any;
  loading: any;
  types: any;

  constructor(public alertController: AlertController,
              private route: ActivatedRoute,
              private change: ChangeDetectorRef,
              public server: ServerService,
              public toastController: ToastController,
              private nav: NavController,
              public loadingController: LoadingController,
              private adminService: AdminService,
              public modalController: ModalController,
              private integrationsService: IntegrationService,) {
    this.percentageFlag = false;
    this.valueFlag = false;
  }


  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    this.data = {};
    this.getSupplierPortfolioStates();
    this.getCategories();
    this.getTypes();
  }

  save(value: any) {
    console.log(value);
  }


  replaceValue() {
    this.value = this.value.replace(/\D/g, '');
  }


  replacePercentageValue() {
    this.percentage = this.percentage.replace(/[^\d.]/g, '');
  }
  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }


  getSupplierPortfolioStates() {
    this.adminService.getSupplierPortfolioStates().subscribe((res: any) => {
      this.states = res;
    });
  }

  async close(data?: any) {
    await this.modalController.dismiss(data);
  }

  setPercentageFlag(checked: boolean) {
    this.percentageFlag = checked;
    console.log(this.percentageFlag);
    this.change.detectChanges();
  }

  setValueFlag(checked: boolean) {
    this.valueFlag = checked;
    console.log(this.valueFlag);
    this.change.detectChanges();
  }

 getCategories(){
   this.loading.present();
   this.integrationsService.getProductCategory().subscribe((res: any) => {
     this.categories = res;
     this.loading.dismiss();
   });
 }
  getTypes() {
    this.adminService.getProductTypes().subscribe((res: any) => {
      this.types = res;
    })
  }

 async addSetting(data) {
   //TODO fixme : data mocked
   await this.loading.present();
   data.userId = localStorage.getItem(Constant.userId);
   this.adminService.createSuppliersPortfolio(data).subscribe(response => {
     this.loading.dismiss();
     this.presentToast('Producto configurado con éxito');
     this.ngForm.reset();
     this.close(true);
   }, error => {
     console.warn('Error al configurar producto', error);
     this.loading.dismiss();
     this.presentToast('Error al configurar producto');
   });
  }
}
